import { compactInteger } from 'humanize-plus';

const formatNumber = (number, showFullWord, precision = 0) => {
  if (!number && number !== 0) return '';
  if (number >= 1000 || number <= -1000) {
    if (showFullWord) {
      return compactInteger(number, precision)
        .replace('M', ' Million')
        .replace('B', ' Billion');
    } else {
      return compactInteger(number, precision);
    }
  } else {
    return String(number);
  }
};

export const percentageFormatter = val => `${Math.round(val * 100) / 100}%`;

export const formatCompensations = num => {
  if (!num) return '--';
  return `$${num.toLocaleString('en-US', { maximumFractionDigits: 0 })}`;
};

export const roundNumber = (num, roundTo) =>
  num.toLocaleString('en-US', { minimumFractionDigits: roundTo, maximumFractionDigits: roundTo });

export default formatNumber;
